import { Link } from 'react-router-dom';
import { SEOHead } from '../components/seo/SEOHead';

export default function Privacy() {
  return (
    <>
      <SEOHead page="privacy" />
      
      <div data-testid="privacy-page">
        {/* Hero Section */}
        <section className="bg-[hsl(215,50%,23%)] text-white py-8 md:py-12">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <p className="text-white/70 text-sm uppercase tracking-wide mb-2">Legal</p>
            <h1 className="text-2xl md:text-3xl font-bold mb-2 text-white">Privacy Policy</h1>
            <p className="text-white/70">Effective Date: January 1, 2026</p>
          </div>
        </section>

      {/* Content */}
      <section className="gov-section bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="prose max-w-none">
            <div className="gov-panel space-y-8">
              
              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Introduction</h2>
                <p className="text-gray-700 mb-4">
                  Canadian Document Services Inc. ("CDS", "we", "us", or "our") is a federally incorporated Canadian company providing private administrative document preparation services.
                </p>
                <div className="bg-[hsl(210,20%,96%)] border border-gray-200 p-4 rounded-sm">
                  <p className="text-gray-700 text-sm">
                    <strong>Registered Office:</strong><br />
                    5000 Yonge St. Suite 1901<br />
                    North York, ON M2N 7E9<br />
                    Canada
                  </p>
                </div>
                <p className="text-gray-700 mt-4">
                  This Privacy Policy complies with the Personal Information Protection and Electronic Documents Act (PIPEDA) and other applicable Canadian privacy laws.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Personal Information We Collect</h2>
                <p className="text-gray-700 mb-4">
                  CDS collects only the personal information reasonably necessary to provide administrative document preparation services, including:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Full legal name, date and place of birth</li>
                  <li>Address and contact information</li>
                  <li>Court records and sentencing documents</li>
                  <li>Police records (local, provincial, RCMP)</li>
                  <li>Government-issued identification numbers</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Purpose of Collection</h2>
                <p className="text-gray-700 mb-4">
                  Personal information is collected solely for:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Conducting administrative eligibility review</li>
                  <li>Preparing application materials</li>
                  <li>Coordinating supporting documentation</li>
                  <li>Communicating regarding file status</li>
                  <li>Internal compliance and record-keeping</li>
                </ul>
                <div className="bg-green-50 border border-green-200 p-4 rounded-sm mt-4">
                  <p className="text-green-800 text-sm font-medium">
                    CDS does not sell personal information.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Disclosure of Personal Information</h2>
                <p className="text-gray-700 mb-4">
                  Personal information may be disclosed only:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>To government authorities with written consent</li>
                  <li>To authorized CDS personnel involved in administrative preparation</li>
                  <li>To contracted service providers performing secure document handling</li>
                  <li>As required by law</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Safeguards</h2>
                <p className="text-gray-700 mb-4">
                  CDS maintains administrative, technical, and physical safeguards including:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Encrypted data transmission (SSL/TLS)</li>
                  <li>Role-based access controls</li>
                  <li>Restricted internal file access</li>
                  <li>Secure document handling procedures</li>
                  <li>Staff confidentiality obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Your Rights</h2>
                <p className="text-gray-700 mb-4">
                  Applicants have the right to request access to their personal information and to request corrections. Requests must be submitted in writing to our Privacy Officer.
                </p>
                <div className="bg-[hsl(210,20%,96%)] border border-gray-200 p-4 rounded-sm">
                  <p className="text-gray-700 text-sm">
                    <strong>Privacy Officer Contact:</strong><br />
                    Canadian Document Services Inc.<br />
                    5000 Yonge St. Suite 1901<br />
                    North York, ON M2N 7E9<br />
                    Email: processing@canadiandocumentservices.com
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Cookies and Tracking</h2>
                <p className="text-gray-700">
                  This website uses cookies and similar technologies to improve functionality and analyze usage. Users may adjust browser settings to decline cookies where supported.
                </p>
              </section>

            </div>
          </div>

          {/* Back Link */}
          <div className="mt-8 text-center">
            <Link to="/" className="text-[hsl(210,80%,40%)] hover:text-[hsl(210,80%,30%)] text-sm">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
      </div>
    </>
  );
}
